exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".CircleRadius-module__wrapper___Fmq3c{position:absolute}.CircleRadius-module__wrapper___Fmq3c .CircleRadius-module__circle___2gXlf{width:100%;height:100%;border-radius:100%;transform:translate(-50%,-50%);position:relative;top:50%;left:50%}.CircleRadius-module__wrapper___Fmq3c .CircleRadius-module__item___2Bw3u{position:absolute}", ""]);

// exports
exports.locals = {
	"wrapper": "CircleRadius-module__wrapper___Fmq3c",
	"circle": "CircleRadius-module__circle___2gXlf",
	"item": "CircleRadius-module__item___2Bw3u"
};